import { LOADED, ADDBOOK, UPDATEBOOK, DELETEBOOK  } from "./actionTypes";

export const loaded = (books)=>{
    return{
        type: LOADED,
        payload: books,
    }
}

export const addbook = (books)=>{
    return{
        type: ADDBOOK,
        payload: books,
    }
}

export const updatebook = (id, data)=>{    
    return{
        type: UPDATEBOOK,
        payload: data,
        id: id,
    }
}

export const deletebook = (id)=>{
    return{
        type: DELETEBOOK,
        payload: id,
    }
}